import rich from './line.label.rich'

export default {
  name: "label",
  nickname: "文本",
  desc:
    '图形上的文本标签，可用于说明图形的一些数据信息，比如值，名称等，<code class="codespan">label</code>选项在 ECharts 2.x 中放置于<code class="codespan">itemStyle</code>下，在 ECharts 3 中为了让整个配置项结构更扁平合理，<code class="codespan">label</code> 被拿出来跟 <code class="codespan">itemStyle</code> 平级，并且跟 <code class="codespan">itemStyle</code> 一样拥有 <code class="codespan">emphasis</code> 状态。',
  type: "object",
  props: {
    show: {
      name: "show",
      nickname: "显示",
      desc: "是否显示标签。",
      value: false,
      defaultValue: false,
    },
    position: {
      name: "position",
      nickname: "位置",
      desc: "标签的位置。",
      value: "top",
      defaultValue: "top",
      type: "pureValue",
    },
    distance: {
      name: "distance",
      nickname: "距离",
      desc:
        '距离图形元素的距离。当 position 为字符描述值（如 <code class="codespan">&#39;top&#39;</code>、<code class="codespan">&#39;insideRight&#39;</code>）时候有效。',
      value: 5,
      defaultValue: 5,
      type: "pureValue",
    },
    rotate: {
      name: "rotate",
      nickname: "旋转",
      desc: "标签旋转。从 -90 度到 90 度。正值是逆时针。",
    },
    offset: {
      name: "offset",
      nickname: "偏移",
      desc:
        '是否对文字进行偏移。默认不偏移。例如：<code class="codespan">[30, 40]</code> 表示文字在横向上偏移 <code class="codespan">30</code>，纵向上偏移 <code class="codespan">40</code>。',
    },
    formatter: {
      name: "formatter",
      nickname: "文本格式化",
      desc:
        '标签内容格式器，支持字符串模板和回调函数两种形式，字符串模板与回调函数返回的字符串均支持用 <code class="codespan">\\n</code> 换行。',
    },
    color: {
      name: "color",
      nickname: "颜色",
      desc: "文字的颜色。",
      value: "#fff",
      defaultValue: "#fff",
      type: "pureValue",
      eType: "color",
    },
    fontStyle: {
      name: "fontStyle",
      nickname: "字体样式",
      desc: "文字字体的风格",
      value: "normal",
      defaultValue: "normal",
      type: "pureValue",
    },
    fontWeight: {
      name: "fontWeight",
      nickname: "字体粗细",
      desc: "文字字体的粗细",
      value: "normal",
      defaultValue: "normal",
      type: "pureValue",
    },
    fontFamily: {
      name: "fontFamily",
      nickname: "字体",
      desc: "文字的字体系列",
      value: "sans-serif",
      defaultValue: "sans-serif",
      type: "pureValue",
    },
    fontSize: {
      name: "fontSize",
      nickname: "字体大小",
      desc: "文字的字体大小",
      value: 12,
      defaultValue: 12,
      type: "pureValue",
    },
    align: {
      name: "align",
      nickname: "对齐",
      desc: "文字水平对齐方式，默认自动。",
    },
    verticalAlign: {
      name: "verticalAlign",
      nickname: "垂直对齐",
      desc: "文字垂直对齐方式，默认自动。",
    },
    lineHeight: {
      name: "lineHeight",
      nickname: "行高",
      desc: "行高。",
    },
    backgroundColor: {
      name: "backgroundColor",
      nickname: "背景色",
      desc: "文字块背景色。",
      value: "transparent",
      defaultValue: "transparent",
      type: "pureValue",
    },
    borderColor: {
      name: "borderColor",
      nickname: "边框颜色",
      desc: "文字块边框颜色。",
      value: "transparent",
      defaultValue: "transparent",
      type: "pureValue",
    },
    borderWidth: {
      name: "borderWidth",
      nickname: "边框宽度",
      desc: "文字块边框宽度。",
      value: 0,
      defaultValue: 0,
    },
    borderRadius: {
      name: "borderRadius",
      nickname: "边框圆角",
      desc: "文字块的圆角。",
      value: 0,
      defaultValue: 0,
    },
    padding: {
      name: "padding",
      nickname: "内边距",
      desc: "文字块的内边距。例如：",
      value: 0,
      defaultValue: 0,
    },
    shadowColor: {
      name: "shadowColor",
      nickname: "阴影颜色",
      desc: "文字块的背景阴影颜色。",
      value: "transparent",
      defaultValue: "transparent",
      type: "pureValue",
    },
    shadowBlur: {
      name: "shadowBlur",
      nickname: "阴影长度",
      desc: "文字块的背景阴影长度。",
      value: 0,
      defaultValue: 0,
    },
    shadowOffsetX: {
      name: "shadowOffsetX",
      nickname: "阴影 X",
      desc: "文字块的背景阴影 X 偏移。",
      value: 0,
      defaultValue: 0,
    },
    shadowOffsetY: {
      name: "shadowOffsetY",
      nickname: "阴影 Y",
      desc: "文字块的背景阴影 Y 偏移。",
      value: 0,
      defaultValue: 0,
    },
    width: {
      name: "width",
      nickname: "宽度",
      desc:
        '文字块的宽度。一般不用指定，不指定则自动是文字的宽度。在想做表格项或者使用图片（参见 <code class="codespan">backgroundColor</code>）时，可能会使用它。',
    },
    height: {
      name: "height",
      nickname: "高度",
      desc:
        '文字块的高度。一般不用指定，不指定则自动是文字的高度。在使用图片（参见 <code class="codespan">backgroundColor</code>）时，可能会使用它。',
    },
    textBorderColor: {
      name: "textBorderColor",
      nickname: "文本边框颜色",
      desc: "文字本身的描边颜色。",
      value: "transparent",
      defaultValue: "transparent",
      type: "pureValue",
    },
    textBorderWidth: {
      name: "textBorderWidth",
      nickname: "文本边框宽度",
      desc: "文字本身的描边宽度。",
      value: 0,
      defaultValue: 0,
    },
    textShadowColor: {
      name: "textShadowColor",
      nickname: "文本阴影宽度",
      desc: "文字本身的阴影颜色。",
      value: "transparent",
      defaultValue: "transparent",
      type: "pureValue",
    },
    textShadowBlur: {
      name: "textShadowBlur",
      nickname: "文本阴影长度",
      desc: "文字本身的阴影长度。",
      value: 0,
      defaultValue: 0,
    },
    textShadowOffsetX: {
      name: "textShadowOffsetX",
      nickname: "文本阴影X偏移",
      desc: "文字本身的阴影 X 偏移。",
      value: 0,
      defaultValue: 0,
    },
    textShadowOffsetY: {
      name: "textShadowOffsetY",
      nickname: "文本阴影Y偏移",
      desc: "文字本身的阴影 Y 偏移。",
      value: 0,
      defaultValue: 0,
    },
    rich,
  },
}
